import React, { useCallback, useState } from "react";
import {
    Edit,
    SimpleForm,
    TextInput,
    BooleanInput,
    Toolbar,
    SaveButton,
} from "react-admin";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { validateRequired } from "../../utils/Validations";
import { useFormState } from "react-final-form";

const useStyles = makeStyles(() => ({
    root: {
        width: "90%",
        margin: "auto"
    },
    warnLabel: {
        fontSize: "10px",
        color: "red",
        display: "block"
    },
}));

const CustomActions = ({ handleSubmitWithRedirect }) => (
    <Toolbar>
        <SaveButton handleSubmitWithRedirect={handleSubmitWithRedirect} />
    </Toolbar>
);

const ParentCategoryEdit = props => {
    const classes = useStyles();

    return (
        <Edit {...props}>
            <SimpleForm redirect="list" toolbar={<CustomActions />}>
                <Render classes={classes} />
            </SimpleForm>
        </Edit>
    );
};

const Render = ({ classes }) => {
    const { values } = useFormState();
    return (
        <Grid container spacing={2} className={classes.root} justify="space-between">
            <Grid item xs={6}>
                <TextInput source="name" validate={validateRequired} label="Category Name" />
            </Grid>
            <Grid item xs={6}>
                <TextInput source="sku_code" validate={validateRequired} label="SKU Code" />
            </Grid>
            <Grid item xs={6}>
                <BooleanInput
                    label={values.active ? "Active" : "Inactive"}
                    source="active"
                    parse={v => (v ? 1 : 0)}
                />
            </Grid>
        </Grid>
    );
};

export default ParentCategoryEdit;
